<template>
  <session class="mobile-page-aboutus">
    <Header />
    <!-- <TopNavs :list="navs" :target="curNav" @click="(target) => tabNav(target)" /> -->

    <Banner :title="bannerTitle" :content="bannerContent" :cover="IMG_BANNER_COVER" />
    
    <div class="aboutus-block">
      <div class="block-header yinhao">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block1Title }}</span>
        <span class="desc" v-html="Utils.presetHtmlText(block1Desc)" />
      </div>
      <div class="block1-body">
        <div class="block-body-nav">
          <div class="item" :class="{ active: item?.name == block1ListCurItem?.name }" v-for="(item, index) in block1List" :key="index" @click="block1ListTabm(index)" @mouseenter="block1ListTab(index)">
            <div class="icon-wrap"><Icon size="18" name="checkmore" /></div>
            <span :class="{ ffen: getLocalLangCode() != 'zh', en: getLocalLangCode() == 'en' }">{{item.name}}</span>
          </div>
        </div>
        <div class="block-body-content">
          <div class="content-wrap">
            <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{block1ListCurItem?.title}}</span>
            <span class="desc">{{block1ListCurItem?.desc}}</span>  
          </div>
          <div class="img-wrap">
            <div class="img" :style="{ backgroundImage: `url(${block1ListCurItem?.cover})` }" />
            <div class="icon-wrap"><Icon name="quotation2" size="54" sizeh="30" /></div>
          </div>
        </div>
      </div>
    </div>

    <div class="aboutus-block">
      <div class="block-header yinhao">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block2Title }}</span>
        <span class="desc" v-html="Utils.presetHtmlText(block2Desc)" />
      </div>
      <div class="block2-body">
        <div class="block-body-content">
          <div class="item" :class="{ active: item?.name == block2ListCurItem?.name }" v-for="(item, index) in block2List" :key="index" @click="block2ListTab(item)">
            <div class="line" />
            <div class="name-wrap">
              <div class="name" :class="{ ffen: getLocalLangCode() != 'zh' }">
                <span>{{ item?.enName }}{{ item?.enName != item?.name ? ` / ${item?.name}` : '' }}</span>
                <span class="position">{{ item?.position }}</span>
              </div>
              <Icon name="plus" size="18" />
            </div>
            <div class="intro-wrap">
              <div class="intro-wrap-i">
                <div class="intro-wrap-ii">
                  <div class="cover" :style="{ backgroundImage: `url(${item?.cover})` }" />
                  <span class="intro" v-html="Utils.presetHtmlText(item?.intro)" />
                </div>
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>

    <div class="aboutus-block" style="background-color: #FFF; margin-bottom: 0;">
      <div class="flight-wrap">
        <div class="flight" :class="{ show: !!show }"><Icon name="flight" size="88" /></div>
        <div class="line" :class="{ show: !!show }" />
      </div>
      <div class="block-header" style="border-top: 0;">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block3Title }}</span>
      </div>
      <div class="block3-body">
        <div class="block-body-content">
          <div class="header-item">
            <span class="desc" v-html="Utils.presetHtmlText(block3Desc)" />
            <div class="covers">
              <div class="item" :style="{ backgroundImage: `url(${IMG_CORPORATE_COVER_t1})` }" />
              <div class="item" :style="{ backgroundImage: `url(${IMG_CORPORATE_COVER_t2})` }" />
              <div class="item" :style="{ backgroundImage: `url(${IMG_CORPORATE_COVER_t3})` }" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="aboutus-block" style="margin-bottom: 0;">
      <div class="block3-body">
        <div class="block-body-content">
          <div class="item" v-for="(item, index) in block3List" :key="index">
            <div class="order">
              <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{item?.order}}</span>
              <div class="title"><Icon :name="item.icon" size="18" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.title }}</span></div>
            </div>
            <div class="desc" v-html="Utils.presetHtmlText(item?.desc)" />
            <div class="cover" :style="{ backgroundImage: `url(${item.cover})` }" />
          </div>
        </div>
      </div>
    </div>

    <div class="joinus">
      <div class="txt"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ joinusTitle }}</span></div>
      <div class="intro">
        <div class="item"><span v-html="Utils.presetHtmlText(joinusContent1)" /></div>
        <div class="item"><span v-html="Utils.presetHtmlText(joinusContent2)" /></div>
      </div>
    </div>

    <Footer />
  </session>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as Utils from '@/assets/utils';
  import { LOCAL, getLocalLangCode } from '@/assets/lang/index';
  import Header from '@/mobile/components/header/index.vue';
  import Footer from '@/mobile/components/footer/index.vue';
  import Banner from '@/mobile/components/banner/index.vue';
  import TopNavs from '@/components/topnavs/index.vue';
  import Icon from '@/components/icon/index.vue';

  // imgs
  import IMG_BANNER_COVER from './images/cover.png';
  
  import IMG_MISSION_COVER_1 from './images/mission_cover_1.png';
  import IMG_MISSION_COVER_2 from './images/mission_cover_2.png';
  import IMG_MISSION_COVER_3 from './images/mission_cover_3.png';
  import IMG_MISSION_COVER_4 from './images/mission_cover_4.png';

  import IMG_LEADERSHIP_COVER_1 from './images/leadership_cover_1.png';
  import IMG_LEADERSHIP_COVER_2 from './images/leadership_cover_2.png';
  import IMG_LEADERSHIP_COVER_3 from './images/leadership_cover_3.png';
  import IMG_LEADERSHIP_COVER_4 from './images/leadership_cover_4.png';
  import IMG_LEADERSHIP_COVER_5 from './images/leadership_cover_5.png';
  
  import IMG_CORPORATE_COVER_t1 from './images/corporate_cover_t1.png';
  import IMG_CORPORATE_COVER_t2 from './images/corporate_cover_t2.png';
  import IMG_CORPORATE_COVER_t3 from './images/corporate_cover_t3.png';
  import IMG_CORPORATE_COVER_1 from './images/corporate_cover_1.png';
  import IMG_CORPORATE_COVER_2 from './images/corporate_cover_2.png';
  import IMG_CORPORATE_COVER_3 from './images/corporate_cover_3.png';

  /**
   * navs
   */
  // banner
  const bannerTitle = ref('')
  const bannerContent = ref('')
  const bannerInit = () => {
    bannerTitle.value = LOCAL('aboutus_aboutUs');
    bannerContent.value = LOCAL('aboutus_aboutUs_desc');
  }
  onMounted(() => {
    bannerInit()
  })

  // 宗旨和价值观
  const block1Title = ref('');
  const block1Desc = ref('');
  const block1List = ref('');
  const block1ListCurItem = ref(null)
  const block1ListTabm = (index = 0) => {
    block1ListCurItem.value = block1List.value[index];
  }
  const block1Initm = () => {
    block1Title.value = LOCAL('aboutus_mission');
    block1Desc.value = LOCAL('aboutus_mission_desc');
    block1List.value = [
      { name: LOCAL('aboutus_mission_1_title'), title: LOCAL('aboutus_mission_1_desc1'), desc: LOCAL('aboutus_mission_1_desc2'), cover: IMG_MISSION_COVER_1 },
      { name: LOCAL('aboutus_mission_2_title'), title: LOCAL('aboutus_mission_2_desc1'), desc: LOCAL('aboutus_mission_2_desc2'), cover: IMG_MISSION_COVER_2 },
      { name: LOCAL('aboutus_mission_3_title'), title: LOCAL('aboutus_mission_3_desc1'), desc: LOCAL('aboutus_mission_3_desc2'), cover: IMG_MISSION_COVER_3 },
      { name: LOCAL('aboutus_mission_4_title'), title: LOCAL('aboutus_mission_4_desc1'), desc: LOCAL('aboutus_mission_4_desc2'), cover: IMG_MISSION_COVER_4 },
    ];
  }
  onMounted(() => {
    block1Initm()
    block1ListTabm()
  });

  // 管理层简介
  const block2Title = ref('');
  const block2Desc = ref('');
  const block2List = ref('');
  const block2Init = () => {
    block2Title.value = LOCAL('aboutus_leadership');
    block2Desc.value = LOCAL('aboutus_leadership_desc');
    block2List.value = [
      { name: LOCAL('aboutus_leadership_1_name')[1], enName: LOCAL('aboutus_leadership_1_name')[0], position: LOCAL('aboutus_leadership_1_poi'), intro: LOCAL('aboutus_leadership_1_desc'), cover: IMG_LEADERSHIP_COVER_1 },
      { name: LOCAL('aboutus_leadership_2_name')[1], enName: LOCAL('aboutus_leadership_2_name')[0], position: LOCAL('aboutus_leadership_2_poi'), intro: LOCAL('aboutus_leadership_2_desc'), cover: IMG_LEADERSHIP_COVER_2 },
      { name: LOCAL('aboutus_leadership_3_name')[1], enName: LOCAL('aboutus_leadership_3_name')[0], position: LOCAL('aboutus_leadership_3_poi'), intro: LOCAL('aboutus_leadership_3_desc'), cover: IMG_LEADERSHIP_COVER_3 },
      { name: LOCAL('aboutus_leadership_4_name')[1], enName: LOCAL('aboutus_leadership_4_name')[0], position: LOCAL('aboutus_leadership_4_poi'), intro: LOCAL('aboutus_leadership_4_desc'), cover: IMG_LEADERSHIP_COVER_4 },
      { name: LOCAL('aboutus_leadership_5_name')[1], enName: LOCAL('aboutus_leadership_5_name')[0], position: LOCAL('aboutus_leadership_5_poi'), intro: LOCAL('aboutus_leadership_5_desc'), cover: IMG_LEADERSHIP_COVER_5 },
    ];
  }
  const block2ListCurItem = ref(null);
  const block2ListTab = target => {
    if(target?.name == block2ListCurItem.value?.name) {
      block2ListCurItem.value = null
    }else{
      block2ListCurItem.value = target;
    }
  }
  onMounted(() => {
    block2Init()
    block2ListTab()
  });

  // 社会责任
  const block3Title = ref('');
  const block3Desc = ref('');
  const block3List = ref([]);
  const block3Init = () => {
    block3Title.value = LOCAL('aboutus_corporate');
    block3Desc.value = LOCAL('aboutus_corporate_desc');
    block3List.value = [
      { order: '01', icon: 'jiankangfupin', title: LOCAL('aboutus_corporate_1_title'), desc: LOCAL('aboutus_corporate_1_desc'), cover: IMG_CORPORATE_COVER_1 },
      { order: '02', icon: 'shequguanhuai', title: LOCAL('aboutus_corporate_2_title'), desc: LOCAL('aboutus_corporate_2_desc'), cover: IMG_CORPORATE_COVER_2 },
      { order: '03', icon: 'huanjingbaohu', title: LOCAL('aboutus_corporate_3_title'), desc: LOCAL('aboutus_corporate_3_desc'), cover: IMG_CORPORATE_COVER_3 },
    ];
  }
  onMounted(() => {
    block3Init()
  });
  const show = ref(false)
  onMounted(() => {
    setTimeout(() => {
      show.value = true
    }, 3000)
  });

  // 加入我们
  const joinusTitle = ref('');
  const joinusContent1 = ref('');
  const joinusContent2 = ref('');
  const joinusInit = () => {
    joinusTitle.value = LOCAL('mobile_aboutus_joinus_title');
    console.log('joinusTitle', joinusTitle.value)
    joinusContent1.value = LOCAL('aboutus_joinus_intro1');
    joinusContent2.value = LOCAL('aboutus_joinus_intro2');
  }
  onMounted(() => {
    joinusInit()
  });
</script>

<style scoped lang="less">
  @import "index.less";
</style>
